<template>
    <main class="page page-dashboard">
        <div class="container">
            <PageHeader
                :title="$translate.text('general.faq')"
            />

            <Accordion
                question='Welke volgorde moet ik hanteren?'
            >
                <p style='padding-top: 10px;'>
                    Registeren <br/>
                    Webshop toevoegen <br/>
                    Feed toevoegen en instellen <br/>
                    Connectie toevoegen en instellen.
                </p>
            </Accordion>

            <Accordion
                question='Lorem ipsum dolor sit amet?'
                answer=''
            ></Accordion>

            <Accordion
                question='Lorem ipsum dolor sit amet?'
                answer=''
            ></Accordion>
        </div>
    </main>
</template>
<script>

import PageHeader from '@/components/PageHeader/PageHeader';
import Accordion from '@/components/Accordion/Accordion';

export default {
    name: 'FAQ',

    components: {
        PageHeader,
        Accordion,
    },

    data() {
        return {

        };
    },

    methods: {

    },
};
</script>
